import authReducer from './slices';

// Auth Actions
export { login, getLoggedInUser, getHomeData } from './authActions';

// Auth Selectors
export const userSelector = (state) => state.auth;
export const loginSelector = (state) => state.auth.login;
export const homeDataSelector = (state) => state.auth.homeData;

// Auth Reducer
export default authReducer;
